import React from 'react';
import styled from 'styled-components';
import { AdminListingDto } from 'services/data-contracts';
import { Row } from 'saladsoft-primitive';
import Text from 'components/commons/Text';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

interface GridItemProps {
  listing: AdminListingDto;
  id: string;
}

const SequenceItem = ({ listing, id }: GridItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 999 : 1,
  };

  return (
    <ItemContainer
      ref={setNodeRef}
      style={style}
      isDragging={isDragging}
      {...attributes}
      {...listeners}
    >
      <div style={{ padding: 10 }}>
        <Row>
          <Text type="H4" style={{ fontSize: 15 }}>
            {listing?.localizedName?.['ko']}
          </Text>
        </Row>
      </div>
    </ItemContainer>
  );
};

const ItemContainer = styled.div<{ isDragging?: boolean }>`
  width: 200px !important;
  /* min-height: 80px; */
  background: ${(props) => (props.isDragging ? '#e6f7ff' : '#f0f0f0')};
  border: ${(props) => (props.isDragging ? '1px dashed #1890ff' : 'none')};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  box-shadow: ${(props) => (props.isDragging ? '0 5px 10px rgba(0,0,0,0.1)' : 'none')};
  transition:
    background-color 0.2s,
    box-shadow 0.2s;
  margin: 0;
  cursor: grab;

  &:hover {
    background: #e6f7ff;
  }

  &:active {
    cursor: grabbing;
  }
`;

const HostawayIdWrapper = styled.div`
  background: #e7e7e7;
  padding: 5px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 400;
`;

export default SequenceItem;
